/**
 * 균일 격자 공간 분할.
 * 매 프레임 clear() 후 적을 전부 다시 넣고, 무기/플레이어가 query로 근처 후보만 본다.
 * Map과 배열을 재사용해서 프레임당 할당이 없다.
 */
export class SpatialHash {
  private readonly cellSize: number;
  private readonly buckets = new Map<number, number[]>();
  private readonly usedKeys: number[] = [];

  constructor(cellSize: number) {
    this.cellSize = cellSize;
  }

  clear(): void {
    for (let i = 0; i < this.usedKeys.length; i++) {
      const b = this.buckets.get(this.usedKeys[i]);
      if (b) b.length = 0;
    }
    this.usedKeys.length = 0;
  }

  private key(cx: number, cy: number): number {
    // 좌표를 16비트로 접어 하나의 정수 키로. 월드가 ±524288px 안이면 충돌 없음.
    return ((cx & 0xffff) << 16) | (cy & 0xffff);
  }

  insert(x: number, y: number, index: number): void {
    const cx = Math.floor(x / this.cellSize);
    const cy = Math.floor(y / this.cellSize);
    const k = this.key(cx, cy);
    let b = this.buckets.get(k);
    if (b === undefined) {
      b = [];
      this.buckets.set(k, b);
    }
    if (b.length === 0) this.usedKeys.push(k);
    b.push(index);
  }

  /** (x,y) 반경 r 안에 있을 수 있는 인덱스를 out에 채운다. out은 비우고 시작한다. */
  query(x: number, y: number, r: number, out: number[]): number[] {
    out.length = 0;
    const cs = this.cellSize;
    const x0 = Math.floor((x - r) / cs);
    const x1 = Math.floor((x + r) / cs);
    const y0 = Math.floor((y - r) / cs);
    const y1 = Math.floor((y + r) / cs);
    for (let cy = y0; cy <= y1; cy++) {
      for (let cx = x0; cx <= x1; cx++) {
        const b = this.buckets.get(this.key(cx, cy));
        if (b === undefined) continue;
        for (let i = 0; i < b.length; i++) out.push(b[i]);
      }
    }
    return out;
  }
}
